module.exports = __webpack_public_path__ + "static/media/left_grey_arrow.715ebaa7.svg";